import UpsaleCardNarrowBox from './UpsaleCardNarrowBox'

export default UpsaleCardNarrowBox
